import * as actionTypes from './actionTypes'
import * as requestActionTypes from '../Request/actionTypes'
import { get } from 'lodash'

export type StateType = {
  states: AreasType
}

const initialState = (): StateType => ({
  states: {},
})

const StatesReducer = (state = initialState(), action: ActionType) => {
  switch (action.type) {
    case requestActionTypes.SUCCEEDED:
      switch (action.meta.sourceType) {
        case actionTypes.STATES_FOR_REGION_REQUESTED: {
          return {
            ...state,
            states: get(action.payload.result, 'states', []).reduce(
              (acc: any, cur: any) => ({
                ...acc,
                [cur.stateCode]: cur.stateName,
              }),
              {},
            ),
          }
        }
        default:
          return state
      }

    default:
      return state
  }
}

export default StatesReducer
